import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg13"
    viewBox="0 0 248.78 250.47"
    {...props}
  >
    <defs id="defs4">
      <style id="style2" />
    </defs>
    <title id="title6">{"IconeComanda"}</title>
    <g id="g827">
      <g
        id="g22"
        style={{
          fill: "#b7b7b7",
          fillOpacity: 1,
        }}
        transform="matrix(2.95913 0 0 2.95913 -24.739 -28.259)"
      >
        <path
          id="path10"
          d="M39.9 48.6c0-3.3.6-6.4 1.7-9.5.7-2 1.9-3.6 4-4.2 1.3-.4 2.7-.4 3.6.8.9 1.2 1.7 2.5.6 4-.3.5-.1.8.2 1.2 2 2.5 4.5 4.1 7.8 4.1 1.4 0 2.8.1 3.1 2v.1c1.8-.3 1.6 1.6 2.7 2.2.8.4 1.4 0 1.9-.5.6-.6 1.1-1.3 1.8-1.8 1.4-1 2.8-.5 3.2 1.2.4 1.5.3 2.9-.2 4.4-.5 1.4-1.5 1.7-2.7 1-.8-.5-1.3-1.3-1.9-1.9-.4-.5-1-.9-1.5-.2-.4.6.1 1.1.6 1.3 2.9 1.4 4.9 3.7 6 6.8.3.9 1.1 1 1.9 1 2.8.3 4.9 1.6 6.6 3.9.2.3.4.6.5.9.1.3.3.7 0 1-.4.3-.6-.2-.8-.4-1.5-1.4-3.1-2.7-5.1-3-2.4-.4-4.5.2-6.4 1.6-1 .7-1.4.5-1.8-.7-1.5-4.4-3-8.7-4.5-13-.4-1.3-1.1-1.9-2.6-1.9-2.7.1-5.1-.8-7.5-2.2-1.5-.9-1.5-.9-1.8.9-.6 3.4-.2 3.9 3.3 4.2 1 .1 2.1.3 3.1.5 1.9.5 3.4 1.6 4 3.6.9 2.9 2.1 5.6 3.2 8.5.5 1.3.7 2.6-.4 3.8-1.6 1.7-3.9 1.3-5-.9-1-2.2-1.9-4.5-2.7-6.8-.5-1.6-1.5-2.2-3.1-2.4-2.3-.2-4.7-.7-7-1.1-2.4-.4-3.8-1.9-4.2-4.4-.4-1.4-.5-2.8-.6-4.1Z"
          className="st0"
          style={{
            fill: "#b7b7b7",
            fillOpacity: 1,
          }}
        />
        <path
          id="path14"
          d="M44.5 58.2c2.6 0 3.2 1 2.4 3.4-.9 2.7.1 5.2 1 7.6.3.9 1.2.9 2.1.9h11.5c.6 0 1.2-.1 1.7.3.6.5.5 1.2.4 1.9-.2.8-.8.8-1.4.8H46.8c-2 0-2.1-.1-2.4-2.1-.4-3.7-2.2-6.4-5.7-7.6-4.9-1.8-10.2 1.5-11 6.8-.1.4-.1.7-.1 1.1-.2 1.7-2.3 2.7-3.7 1.7-.5-.3-.4-.8-.3-1.2.5-2 1-4.1 1.6-6.1.4-1.4.5-2.7 0-4.1-.8-2.3-.2-3.4 2.2-3.4h17.1z"
          className="st0"
          style={{
            fill: "#b7b7b7",
            fillOpacity: 1,
          }}
        />
        <path
          id="path16"
          d="M77.8 71.3c0 3.2-2.4 5.7-5.6 5.8-3.3 0-5.8-2.4-5.8-5.7 0-3.3 2.5-5.8 5.8-5.8 3.1 0 5.6 2.5 5.6 5.7z"
          className="st0"
          style={{
            fill: "#b7b7b7",
            fillOpacity: 1,
          }}
        />
        <path
          id="path18"
          d="M41.8 71.4c0 3.3-2.6 5.8-5.8 5.7-3.2-.1-5.6-2.6-5.5-5.9.1-3.2 2.6-5.7 5.8-5.7 3.1.1 5.6 2.7 5.5 5.9z"
          className="st0"
          style={{
            fill: "#b7b7b7",
            fillOpacity: 1,
          }}
        />
        <path
          id="path20"
          d="M52.1 22.9c3 0 5.4 2.6 5.4 5.6 0 3-2.5 5.5-5.5 5.5-3.1 0-5.4-2.4-5.4-5.6 0-3.1 2.5-5.5 5.5-5.5z"
          className="st0"
          style={{
            fill: "#b7b7b7",
            fillOpacity: 1,
          }}
        />
      </g>
      <path
        id="path12"
        d="M93.607 66.208c3.486.678 4.655 2.413 4.033 5.608l-8.426 43.279c-.679 3.485-2.3 4.074-5.496 3.452l-43.569-8.483c-3.485-.679-4.945-2.47-4.266-5.956l2.262-11.618c.678-3.486 2.711-3.09 5.907-2.468 2.033.396 4.01 1.083 4.462-1.241l1.98-10.166c.395-2.033-1.751-1.848-3.785-2.244-3.485-.679-5.228-1.018-4.55-4.504l2.037-10.456c.791-4.067 2.413-4.655 6.19-3.92 7.204 1.704 35.96 7.303 43.221 8.717z"
        className="st0"
        style={{
          fill: "#b7b7b7",
          fillOpacity: 1,
          strokeWidth: 2.95912719,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
